import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'fz-copy-link',
  templateUrl: './copy-link.component.html',
  styleUrls: ['./copy-link.component.scss'],
})
export class CopyLinkComponent {
  @Input()
  linkMaxHeigh = false;
  @Input()
  label: string;
  @Input()
  link: string;
  @Output()
  oncopy = new EventEmitter<void>();

  onCopy(): void {
    this.oncopy.emit();
  }
}
